module.exports = __webpack_public_path__ + "img/realtime.10a054ce.svg";